module.exports = __webpack_public_path__ + "img/datu.7ef30680.png";